import { createAction } from 'redux-actions';
import { createActionBundle } from 'utilities/request';

export const {
  fetch: createPatient,
  request: requestCreatePatient,
  success: requestCreatePatientSuccess,
  failure: requestCreatePatientFailure,
} = createActionBundle('PATIENT/CREATE');

export const {
  request: requestPatientList,
  success: requestPatientListSuccess,
  failure: requestPatientListFailure,
} = createActionBundle('PATIENT/LIST');

export const {
  request: requestGetListCardiovascularInvestigations,
  success: requestGetListCardiovascularInvestigationsSuccess,
  failure: requestGetListCardiovascularInvestigationsFailure,
} = createActionBundle('CARDIOVASCULAR_INVESTIGATIONS/GET_LIST');

export const patientSubmitEditForm = createAction('PATIENT/SUBMIT_EDIT_FORM');

export const patientSubmitChangePasswordForm = createAction('PATIENT/SUBMIT_CHANGE_PASSWORD_FORM');

export const {
  request: requestPatientsResourceById,
  success: requestPatientsResourceByIdSuccess,
  failure: requestPatientsResourceByIdFailure,
} = createActionBundle('PATIENTS_RESOURCE_BY_ID');

export const {
  request: requestPutPatientById,
  success: requestPutPatientByIdSuccess,
  failure: requestPutPatientByIdFailure,
} = createActionBundle('PUT_PATIENT_BY_ID');

export const {
  request: requestPutChangePatientsPassword,
  success: requestPutChangePatientsPasswordSuccess,
  failure: requestPutChangePatientsPasswordFailure,
} = createActionBundle('PUT_CHANGE_PATIENTS_PASSWORD');
